// import React, { useEffect, useState } from 'react';
// import { useSearchParams } from 'react-router-dom';
// import './PaymentSuccess.css';

// const PaymentSuccess = () => {
//   const [searchParams] = useSearchParams();
//   const [status, setStatus] = useState('Loading...');

//   useEffect(() => {
//     const sessionId = searchParams.get('session_id');

//     if (sessionId) {
//       // Simulating payment verification with session_id
//       setTimeout(() => {
//         setStatus('Payment Successful! Thank you for your purchase.');
//       }, 2000);
//     } else {
//       setStatus('Payment Failed or Cancelled.');
//     }
//   }, [searchParams]);

//   return (
//     <div>

//       <h1>Payment Status</h1>
//     <div className="payment-success">
//       <h2>{status}</h2>
//     </div>
//     </div>
//   );
// };

// export default PaymentSuccess;


import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios'; // Import Axios for API calls
import './PaymentSuccess.css';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('Loading...');
  const [sessionId, setSessionId] = useState(null);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    setSessionId(sessionId);

    if (sessionId) {
      // Verify the payment status with Stripe
      axios
        .post('https://api.stripe.com/v1/checkout/sessions', null, {
          headers: {
            Authorization: `Bearer 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`, // Replace with your Stripe secret key
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          params: {
            session_id: sessionId,
          },
        })
        .then((response) => {
          const paymentStatus = response.data.payment_status;

          if (paymentStatus === 'paid') {
            // Call backend to add tokens
            const userId = localStorage.getItem('user_id'); // Fetch user ID from local storage or context
            const tokenCount = parseInt(response.data.metadata.token_count, 10); // Assume `token_count` is passed as metadata in the Stripe session

            axios
              .post('/add-tokens', { user_id: userId, token_count: tokenCount })
              .then(() => {
                setStatus(`Payment Successful! ${tokenCount} tokens have been added to your account.`);
              })
              .catch((error) => {
                setStatus('Payment Successful, but there was an error adding tokens.');
                console.error('Error adding tokens:', error);
              });
          } else {
            setStatus('Payment Failed or Incomplete.');
          }
        })
        .catch((error) => {
          setStatus('Error verifying payment.');
          console.error('Stripe session verification error:', error);
        });
    } else {
      setStatus('Payment Failed or Cancelled.');
    }
  }, [searchParams]);

  return (
    <div className="payment-success-container">
      <h1>Payment Status</h1>
      <div className="payment-success">
        <h2>{status}</h2>
      </div>
    </div>
  );
};

export default PaymentSuccess;
